<template>
  <div>
    <van-nav-bar
      id="xy-navBar--isTransparent"
      :class="{ 'xy-navBar--isTransparent': style_isTransparent }"
      fixed
    >
      <van-icon name="arrow-left" color="#333" size="19" slot="left" @click="onClickLeft" />
      <div slot="title">
        <div v-if="isMsg">{{ titleName }}</div>
        <div v-else>
          <span>{{ moduleData.Name }}</span>
        </div>
      </div>
    </van-nav-bar>
  </div>
</template>
<script>
export default {
  name: "headnav",
  data() {
    return {
      isMsg: false,
      titleName: ""
    };
  },
  computed: {
    moduleData() {
      return JSON.parse(this.$store.state.parentInfo.moduleData);
    },
    style_isTransparent() {
      return this.$store.state.globalNavBar_transparentMode;
    }
  },
  created() {
    console.log("-----------------");
  },
  mounted() {
    if (this.$route.query.fromMessage) {
      this.isMsg = true;
      // 从消息页面跳转
      this.titleName = JSON.parse(this.$store.state.messageInfo).MessageTypeName;
    } else {
      // 从列表跳转
      this.isMsg = false;
    }
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    }
  }
};
</script>
<style lang="less" scoped>
::v-deep .xy-navBar--isTransparent {
  /* 头部背景设置：将Vant的导航栏设置为透明背景 */
  .van-nav-bar__title {
    color: #fff;
  }
  &.van-nav-bar--fixed.van-hairline--bottom {
    background-color: transparent;
    .van-nav-bar:after {
      content: none;
    }
  }
  .van-icon.van-icon-arrow-left {
    color: #fff !important;
  }
  &.van-hairline--bottom:after {
    border-bottom-width: 0;
  }
}
</style>
